// safe-img.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

const ALLOWED_ORIGINS = [
  window.location.origin,
];

@Pipe({ name: 'safeImg', pure: true })
export class SafeImgPipe implements PipeTransform {
  transform(url: unknown): string | null {
    if (typeof url !== 'string' || !url) return null;
    try {
      const u = new URL(url, window.location.origin);
      const schemeOk = u.protocol === 'http:' || u.protocol === 'https:';
      const originOk = ALLOWED_ORIGINS.includes(u.origin);
      if (schemeOk && originOk) return u.toString();
      return null;
    } catch {
      return null;
    }
  }
}
